var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cil:education"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.5 33.3728L24 39.2791L13.5 33.3728V27.1326L10.5 25.4659V35.1273L24 42.721L37.5 35.1273V25.4659L34.5 27.1326V33.3728Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24 4.8103L3 15.6992V18.2992L24 29.9656L42 19.9659V28.25H45V15.6992L24 4.8103ZM39 18.2007L36 19.8673L24 26.5343L12 19.8673L9 18.2007L6.92072 17.0455L24 8.18962L41.0793 17.0455L39 18.2007Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.00470e09cd9ef6fbc96ad80e86b1f8c7.svg";
export { ForwardRef as ReactComponent };